import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/data-not-found.svg'


const _hoisted_1 = { class: "flex flex-col font-montserrat overflow-hidden h-screen relative" }
const _hoisted_2 = {
  key: 1,
  class: "w-full h-full bg-white justify-center items-center flex flex-col mx-auto py-20 text-12px xxl:text-14px overflow-hidden border-t border-gray-lp-200"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-32 mt-8 mx-auto",
  alt: "not_found"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "text-gray-lp-300 py-2 font-bold" }, " Data tidak ditemukan pada halaman ini ", -1)
const _hoisted_5 = { class: "absolute w-full bottom-0" }
const _hoisted_6 = { class: "overflow-y-auto h-screen pb-20" }
const _hoisted_7 = { class: "absolute w-full bottom-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_TableLazyLoad = _resolveComponent("TableLazyLoad")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_TableV1 = _resolveComponent("TableV1")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Header, {
      isSearchable: true,
      isSelectStatus: true,
      placeholder: "Cari nama lokasi",
      searchValue: _ctx.search,
      searchAction: _ctx.onSearch,
      clearSearch: _ctx.clearSearch,
      statusData: _ctx.statusData,
      onOpenStatusSelect: _ctx.onOpenStatusSelect,
      onCloseStatusSelect: _ctx.onCloseStatusSelect,
      onSelectStatus: _ctx.onSelectStatus,
      valueStatus: _ctx.statusName,
      statusSelect: _ctx.statusSelect
    }, null, 8, ["searchValue", "searchAction", "clearSearch", "statusData", "onOpenStatusSelect", "onCloseStatusSelect", "onSelectStatus", "valueStatus", "statusSelect"]),
    _withDirectives(_createVNode(_component_TableLazyLoad, { columns: _ctx.columns }, null, 8, ["columns"]), [
      [_vShow, _ctx.isLoading]
    ]),
    _withDirectives(_createVNode(_component_ErrorMessage, {
      errorType: _ctx.errorCause,
      onTryAgain: _ctx.getListData
    }, null, 8, ["errorType", "onTryAgain"]), [
      [_vShow, _ctx.isError && !_ctx.isLoading]
    ]),
    (!_ctx.regionListData.length && !_ctx.isLoading && _ctx.page === 1 && !_ctx.isError)
      ? (_openBlock(), _createBlock(_component_EmptyState, {
          key: 0,
          customHeaderMessage: "Belum Ada Grup Wilayah",
          customMessage: "Mulai buat konfigurasi untuk wilayah grup pengiriman"
        }))
      : _createCommentVNode("", true),
    (
        _ctx.regionListData?.length === 0 && !_ctx.isLoading && _ctx.page !== 1 && !_ctx.isError
      )
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_Pagination, {
              onNext: _ctx.nextPage,
              onPrevious: _ctx.prevPage,
              page: _ctx.page,
              toPage: _ctx.toPage
            }, null, 8, ["onNext", "onPrevious", "page", "toPage"])
          ])
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode("div", _hoisted_6, [
      _createVNode(_component_TableV1, {
        columns: _ctx.columns,
        data: _ctx.regionListData,
        class: "my-2"
      }, null, 8, ["columns", "data"])
    ], 512), [
      [_vShow, !_ctx.isLoading && _ctx.regionListData?.length !== 0 && !_ctx.isError]
    ]),
    _withDirectives(_createVNode("div", _hoisted_7, [
      _createVNode(_component_Pagination, {
        onNext: _ctx.nextPage,
        onPrevious: _ctx.prevPage,
        page: _ctx.page,
        isButtonNext: _ctx.regionListData?.length >= _ctx.limit,
        totalData: _ctx.regionListData?.length,
        toPage: _ctx.toPage
      }, null, 8, ["onNext", "onPrevious", "page", "isButtonNext", "totalData", "toPage"])
    ], 512), [
      [_vShow, !_ctx.isLoading && _ctx.regionListData?.length !== 0 && !_ctx.isError]
    ])
  ]))
}